<template>
  <div v-if="viewTangibles">
    <label class="flex-label" style="color: #333; padding-bottom: 10px">
      <input
        type="checkbox"
        id="checkbox"
        v-model="application.has_radioactive_cargo"
        :disabled="this.disabledInput"
      />
      &nbsp;
      Характер груза предполагает возможный радиационный фон
    </label>
    <div class="row">
    </div>
    <div class="row">
      <div class="col-md-4">
        <span>Наименование</span>
      </div>
      <div class="col-md-4">
        <span>Количество</span>
      </div>
      <div :class="{'col-md-2 col-xs-9': canRemoveTangibles, 'col-md-3': !canRemoveTangibles}">
        <span style="white-space: nowrap">Идентификатор / ед. измерения</span>
      </div>
      <div class="col-md-1 col-xs-3" v-if="canRemoveTangibles">
        <span></span>
      </div>
    </div>
    <div v-for="(tangible, tangiblesKey) in tangibles" :key="tangiblesKey" class="row">
    <div class="col-md-4 mt-10">
      <tangibles-input
        :form="form"
        :errors="errors"
        :disabled="disabledTangibles"
        :tangibles-id="tangiblesKey"
        v-model="tangible.name"
        @change="change('Tangibles name')"
      />
    </div >
      <div class="col-md-4 mt-10" >
        <tangibles-count
            :form="form"
            :errors="errors"
            :disabled="disabledTangibles"
            :tangibles-id="tangiblesKey"
            v-model="tangible.count"
            @change="change('Tangibles count')"
        />
      </div>
    <div :class="{'col-md-3 col-xs-9': canRemoveTangibles, 'col-md-4': !canRemoveTangibles}" class="mt-10">
      <tangibles-identification
        :form="form"
        :errors="errors"
        :disabled="disabledTangibles"
        :tangibles-id="tangiblesKey"
        v-model="tangible.identification"
        @change="change('Tangibles identification')"
      />
    </div>
      <div class="col-md-1 col-xs-3" v-if="canRemoveTangibles">
        <div class="form-group mt-10">
          <button
            type="button"
            style="display: block"
            :id="`btn-${{tangiblesKey}}`"
            class="btn btn-sm btn-default form-control"
            @click="removeTangibles(tangiblesKey)"
            title="Удалить"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
    </div>
  </div>
    <div class="tangibles-add" v-if="!isView">
      <div class="text-center">
        <div class="addNewVessel" id="form-vessels-button">
          <button type="button" class="btn btn-default" @click="addTangible">Добавить наименование</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import TangiblesCount from '@/common/components/application/form-inputs/pass/tangibles/TangiblesCount.vue'
import TangiblesIdentification from '@/common/components/application/form-inputs/pass/tangibles/TangiblesIdentification.vue'
import TangiblesInput from '@/common/components/application/form-inputs/pass/tangibles/TangiblesInput.vue'

export default {
  name: 'TangiblesFormBlock',

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin
  ],

  components: {
    TangiblesInput,
    TangiblesIdentification,
    TangiblesCount
  },

  model: {
    prop: 'change-tangibles',
    event: 'change-tangibles'
  },

  props: {
    tangibles: {
      type: Array,
      default: () => [],
      required: true
    },

    application: {
      type: Object,
      required: true
    },

    applicationPurpose: {
      type: [Array, Object]
    }
  },

  created () {
    if (this.tangibles.length > 0) {
      this.form.tangibles = []
    }
  },

  computed: {
    disabledTangibles () {
      return Boolean(this.disabledInput)
    },

    viewTangibles () {
      return this.isPassKindMaterial
    },

    canRemoveTangibles () {
      return Boolean(this.isPassKindMaterial && this.tangibles.length > 1 && !this.isView)
    }
  },

  data: () => {
    return {
      baseUrl: process.env.BASE_URL
    }
  },

  methods: {
    change (inputName) {
      Logger.log(`Changed ${inputName}!`)
      this.$emit('change-tangibles', this.tangibles)
    },

    removeTangibles (tangiblesKey) {
      this.tangibles.splice(tangiblesKey, 1)
    },

    addTangible () {
      const tangible = Object.assign({}, {
        name: null,
        identification: null,
        count: null
      })
      this.tangibles.push(tangible)
    }
  }
}
</script>
